import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import media from './../../../common/MediaQueries'
import { WithTheme } from '../../../setup'

const StayConnectedStyled = styled.div`
  width: 100%;
  border: 0.0625rem solid #707070;
  border-radius: 0.3125rem;
  padding: 0 0.625rem 1.625rem;

  @media ${media.phone} {
    padding: 0 2.5rem 1.75rem 2.5rem;
  }
`

const StayConnectedTitleStyled = styled(Text)<WithTheme>`
  position: relative;
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  padding: 0.625rem;
  font-size: 1.25rem;
  top: -1.4375rem;
  margin-left: 0.875rem;

  @media ${media.phone} {
    top: -1.5rem;
    margin-left: -0.625rem;
    margin-bottom: 0.25rem;
  }
`

const StayConnectedListStyled = styled.div``

export { StayConnectedStyled, StayConnectedTitleStyled, StayConnectedListStyled }
